import ResourceStore from "../../../shared/services/ResourceStore";

class CustomerStore extends ResourceStore {
  _baseUrl (_params) {
    return "/api/v4";
  }

  async fetchReportItems (merchantId, customerId) {
    let response = await fetch(
      "/api/v4/invoices?" +
      `company_id=${merchantId}&` +
      `customer_id=${customerId}`
    );

    return response.json();
  }

  async createModal () {
    const response = await fetch(
      `${this._baseUrl()}/customers`, {
        body: new FormData(document.getElementById("new-customer-form")),
        method: "POST"
      });

    return this._handleResponse(response);
  }
};

export default new CustomerStore("customer");
